// @ts-nocheck
// TODO: tighten types after migration
import React from "react";
import { FiFlag, FiMoreHorizontal, FiTrash2 } from "react-icons/fi";
import { CommentCurrentUser, CommentRecord } from "./types";

interface CommentItemProps {
  comment: CommentRecord;
  level: number;
  user: CommentCurrentUser | null;
  activeMenu: string | null;
  actionStatus: Record<string, "loading" | "success" | undefined>;
  onToggleMenu: (id: string) => void;
  onDeleteComment: (id: string) => void;
  onReportComment: (id: string) => void;
  onSetReplyTo: (id: string) => void;
  formatTimestamp: (value: string) => string;
}

export default function CommentItem(props: CommentItemProps) {
  const {
    comment,
    level,
    user,
    activeMenu,
    actionStatus,
    onToggleMenu,
    onDeleteComment,
    onReportComment,
    onSetReplyTo,
    formatTimestamp,
  } = props;

  return (
    <div className={`comment-container ${level === 1 ? "comment-reply" : ""}`}>
      <div className="comment-main">
        <div className="comment-user-avatar">
          {comment.userName ? comment.userName.charAt(0).toUpperCase() : "U"}
        </div>
        <div className="comment-content">
          <div className="comment-header-row">
            <div className="comment-info">
              <span className="comment-author">{comment.userName}</span>
              <span className="comment-date">{formatTimestamp(comment.timestamp)}</span>
            </div>
            <div className="comment-more-container">
              <FiMoreHorizontal className="comment-more-icon" onClick={() => onToggleMenu(comment._id)} />
              {activeMenu === comment._id && (
                <div className="comment-actions-dropdown">
                  {user && user._id === comment.userId ? (
                    <button
                      className={`action-item item-delete ${actionStatus[comment._id] ? `status-${actionStatus[comment._id]}` : ""}`}
                      onClick={() => actionStatus[comment._id] !== "loading" && onDeleteComment(comment._id)}
                      disabled={actionStatus[comment._id] === "loading"}
                    >
                      {actionStatus[comment._id] === "loading"
                        ? "Deleting..."
                        : actionStatus[comment._id] === "success"
                          ? "Deleted"
                          : (<><FiTrash2 /> Delete</>)}
                    </button>
                  ) : (
                    <button className="action-item item-report" onClick={() => onReportComment(comment._id)}>
                      <FiFlag /> Report
                    </button>
                  )}
                </div>
              )}
            </div>
          </div>

          <div className="comment-text">{comment.commentText}</div>
          {user && level === 0 && (
            <button onClick={() => onSetReplyTo(comment._id)} className="reply-button">
              Reply
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
